import React from "react";
import { FaRulerCombined, FaHammer, FaCouch } from "react-icons/fa";
import kitchenBanner from "../assets/banner1.jpg";

export default function Cabinets() {
  return (
    <div className="MainBodySection py-5" style={{ backgroundColor: "#f9f9f9" }}>
      <div className="container position-relative">
        {/* HEADER */}
        <div className="text-center mb-5">
          <h2 className="main-section-title text-primary">
            Kitchen Cabinet Design & Manufacturing
          </h2>
          <p className="text-muted fs-6">
            High-quality custom kitchen cabinets tailored for functionality and style.
          </p>
        </div>

        {/* BANNER IMAGE */}
        <div className="bg-light rounded shadow-sm mb-5 p-3">
          <img
            src={kitchenBanner}
            alt="Kitchen Cabinets"
            className="img-fluid rounded w-100"
            style={{ maxHeight: 420, objectFit: "cover" }}
          />
        </div>

        {/* SERVICE DESCRIPTION */}
        <div className="bg-white rounded shadow-sm p-4 mb-5">
          <p className="text-muted fs-6 mb-4">
            Kitchen Kings TZ specializes in designing and manufacturing high-quality kitchen cabinets. Our cabinets are tailored to your kitchen’s layout and style, providing both durability and aesthetic appeal. We work with premium woods and MDF boards to ensure long-lasting functionality.
          </p>

          {/* KEY HIGHLIGHTS */}
          <ul className="list-unstyled mb-4">
            <li className="mb-3 d-flex align-items-start">
              <FaRulerCombined size={22} className="me-3 text-primary" />
              <span>Custom design to perfectly fit your kitchen space and style preferences.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaHammer size={22} className="me-3 text-primary" />
              <span>High-quality construction using premium wood and MDF boards for durability.</span>
            </li>
            <li className="mb-3 d-flex align-items-start">
              <FaCouch size={22} className="me-3 text-primary" />
              <span>Functional storage solutions that enhance kitchen efficiency and organization.</span>
            </li>
          </ul>

          {/* PROCESS / WORKFLOW */}
          <ol className="fs-6 mb-3">
            <li>Collaborate with clients to understand storage needs and design preferences.</li>
            <li>Create detailed design and layout plans for client approval.</li>
            <li>Professional manufacturing and finishing to ensure longevity and aesthetic appeal.</li>
            <li>Installation and final quality inspection for a seamless experience.</li>
          </ol>

          <p className="text-muted fs-6 mt-3">
            Our focus is on delivering <strong>custom kitchen cabinets</strong> that combine style, functionality, and durability, providing a premium solution for both residential and commercial kitchens.
          </p>
        </div>
      </div>
    </div>
  );
}
